import React from 'react';
import { Container, Skeleton, Stack, styled, Typography } from '@mui/material';

const SButton = styled(Skeleton)({
  height: '32px',
});

const testPlanDetailsEditHeaderLoader = (
  <Container maxWidth="lg" disableGutters sx={{ py: 4 }}>
    <Stack gap={4} alignItems="start">
      <SButton width="120px" />
      <Stack direction="row" gap={1.5} justifyContent="space-between" width="100%" alignItems="center">
        <Typography variant="h4" component="h1">
          <Skeleton width="220px" />
        </Typography>
        <Stack direction="row" gap={2}>
          <SButton width="120px" />
          <SButton width="90px" />
          <SButton width="90px" />
          <SButton width="70px" />
          <SButton width="120px" />
        </Stack>
      </Stack>
    </Stack>
  </Container>
);

export const testPlanDetailsEditLoader = (
  <Container>
    <Stack gap={4}>
      {testPlanDetailsEditHeaderLoader}
      <Skeleton width="100%" height="50vh" />
    </Stack>
  </Container>
);

export const testPlanPropertiesForm = (
  <Stack gap={2}>
    <Skeleton width="220px" variant="rounded" height="32px" />
    <Skeleton width="100%" variant="rounded" height="80px" />
    <Skeleton width="100%" variant="rounded" height="10lh" />
    <Skeleton width="100%" variant="rounded" height="80px" />
    <Skeleton width="100%" variant="rounded" height="80px" />
    <Skeleton width="100%" variant="rounded" height="80px" />
    <Skeleton width="100%" variant="rounded" height="80px" />
    <Skeleton width="100%" variant="rounded" height="3lh" />
  </Stack>
);
